import React, { useEffect, useState } from "react";
import { Button, Card, Col, Nav, Row, Table, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import ReactApexChart from "react-apexcharts";
import AntenatalTable from "../components/tables/antenatalTable";
import AppointmentSidebar from "../components/common/appointmentSidebar";
import AppointmentSidebar2 from "../components/common/Recent&Transaction";

export default function AntenatalHistory() {
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = useState(currentSkin);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const switchSkin = (skin) => {
    if (skin === "dark") {
      document.querySelectorAll(".btn-white").forEach((btn) => {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      });
    } else {
      document.querySelectorAll(".btn-outline-primary").forEach((btn) => {
        btn.classList.remove("btn-outline-primary");
        btn.classList.add("btn-white");
      });
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const chartOptions = {
    chart: {
      type: "bar",
      height: 350,
    },
    colors: ["#6f42c1"], // Purple color
    series: [
      {
        name: "Visits",
        data: [1, 2, 3, 4],
      },
    ],
    xaxis: {
      categories: [
        "Week 1", "Week 2", "Week 3", "Week 4",
      ],
    },
  };

  const antenatalData = [
    { id: 1, doctor: "Dr. Smith", dept: "Obstetrics", service_type: "Check-up", appointment_type: "Routine", date: "2025-03-15", time: "10:00 AM" },
    { id: 2, doctor: "Dr. Johnson", dept: "Obstetrics", service_type: "Ultrasound", appointment_type: "Routine", date: "2025-03-22", time: "11:00 AM" },
    { id: 3, doctor: "Dr. Adams", dept: "Gynecology", service_type: "Consultation", appointment_type: "Follow-up", date: "2025-03-29", time: "9:30 AM" }
  ];

  const openDetailsModal = (item) => {
    setSelectedAppointment(item);
    setShowDetailsModal(true);
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
    <Row>
      <Col xl="9">
      <div className="main main-app p-3 p-lg-4">
        <Row className="mt-4">
          <Col >
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6">Weekly Antenatal Visits Progress</Card.Title>
              </Card.Header>
              <Card.Body>
                <ReactApexChart options={chartOptions} series={chartOptions.series} type="bar" height={350} />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <div className="mt-5 ">
          <h2 className="fw-normal">Antenatal History</h2>
          <p className="text-muted">Comprehensive overview of your antenatal visits, medical history, and observations.</p>
        </div>

        <AntenatalTable/>

       
        <Footer />
      </div>
      </Col>
      <AppointmentSidebar2/>
    </Row>
    </React.Fragment>
  );
}
